// This module holds a reference to the Vue app instance
// Used by Vuex store modules that need to access app.config.globalProperties
// (replaces the Vue 2 pattern of using this._vm)

let appInstance = null;

export function setAppInstance(app) {
  appInstance = app;
}

export function getAppInstance() {
  return appInstance;
}

// Convenience getters for commonly used global properties
export function getAnalytics() {
  const instance = getAppInstance();
  return instance && instance.config && instance.config.globalProperties ? instance.config.globalProperties.$analytics : undefined;
}

export function getApptimize() {
  const instance = getAppInstance();
  return instance && instance.config && instance.config.globalProperties ? instance.config.globalProperties.$apptimize : undefined;
}

export function getCookie() {
  const instance = getAppInstance();
  return instance && instance.config && instance.config.globalProperties ? instance.config.globalProperties.$cookies : undefined;
}

export function getAccess() {
  const instance = getAppInstance();
  return instance && instance.config && instance.config.globalProperties ? instance.config.globalProperties.$access : undefined;
}
